import React, { useState } from 'react'
import SubCover from '../../SubCover/SubCover';
import ImageBuffer from '../../ImageBuffer/ImageBuffer';
import { add } from '../../../assets';
import {Loader} from '../../';

import './submitModal.css'

const SubmitModal = ({onOpen, onClose, onConfirm, prompt, onClickName}: any) => {
    const [onClickConfirm, setOnClickConfirm] = useState<boolean>(false);

    const onHandleClickConfirm = async () => {
        setOnClickConfirm(true);

        await onConfirm();

        setOnClickConfirm(false);
    };

  return (
    <>
        {onOpen && (
            <>
                <div className='submit-modal-wrapper'>
                    <div className={onOpen ? "submit-modal-container active": "submit-modal-container"}>
                        <div className="submit-modal-icon-wrapper">
                            <ImageBuffer src={add} alt='svg' className='submit-modal-icon' />
                        </div>
                        <h2 className="submit-modal-title">{onClickName}</h2>
                        <p className="submit-modal-description">
                            {prompt}
                        </p>
                        <div className="submit-modal-option-wrapper">
                            <button type="button" className="submit-modal-option-cancel" onClick={onClose} >
                                Cancel
                            </button>
                            {onClickConfirm ? (
                                <Loader />
                            ) : (
                                <button type="button" className="submit-modal-option-confirm" onClick={onHandleClickConfirm}>Confirm
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </>
        )}
    </>
  )
}

export default SubmitModal